import { Sms } from './models/sms';
import { Question } from './models/question';
import { User } from './models/user';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Auth } from './Auth';
import { environment, endpoints } from '../../environments/environment';
import { Account } from './models/account';
import { map } from 'rxjs/operators/map';
import { Access } from './models/access';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { BaseResult } from '../shared/models/base.result.model';
import { IBQuestion } from './models/ib-question';
import { Util } from '../utils/util';

@Injectable()
export class AutenticationService {

	accounts: Array<Account> = [];

	constructor(private http: HttpClient) { }

	generateGUID() {
		let GUID = Auth.getInstance().getGUID();

		if (!GUID) {
			GUID = Util.generateUUID4();

			Auth.getInstance().setGUID(GUID);
		}
	}

	auth() {
		const body = new HttpParams()
			.set('username', 'iBanking')
			.set('password', '0mN1InTr84Nk')
			.set('grant_type', 'password');

		const headers = new HttpHeaders()
			.set('Content-Type', 'application/x-www-form-urlencoded')
			.set('Identificador', Auth.getInstance().getGUID());

		return this.http.post(environment.apiUrl + 'auth', body, {
			headers: headers
		}).pipe(map((data: any) => {
			Auth.getInstance().setOnSession('OmniBearerTokenKey', data.access_token);

			Auth.token = data.access_token;

			return data;

		}));

	}

	/**
	 * Lista as contas do usuário via post, após login.
	 *
	 * TODO: Este método é mockado, deve ser adaptado ao serviço real.
	 *
	 * @param cpf:String
	 * @param handler:Function
	 */
	loadAccounts(cpf: string, pass: string): Observable<Account[]> {

		// this.http.get( 'assets/mockup/contas/login.json' ).subscribe((data: any) => {
		return this.http.post(endpoints.accounts.login, { cpf: cpf.replace(/\D/g, ''), senha: pass }).pipe(map((data: any) => {
			if (data.Sucesso) {
				this.accounts = data.Retorno.Adesoes.map((account: any) => {

					const newUser = new User();
					newUser.agency = account.Dados.Agencia;
					newUser.accountName = account.Dados.NomeConta;
					newUser.accountType = account.Dados.TipoConta;
					newUser.accountNumber = account.Dados.NumeroConta;
					newUser.name = account.Dados.NomeTitular;
					newUser.loggedUserName = data.Retorno.NomeUsuario;
					newUser.cpfCnpj = account.Dados.CpfCnpj;
					newUser.personType = account.Dados.TipoPessoa;
					newUser.cpf = cpf.replace(/\D/g, '');
					newUser.tokenSms = data.Retorno.TipoToken === 'SMS' ? true : false;
					newUser.rule = account.Poder[0];

					const newAcc = new Account();
					newAcc.rights = account.Poder[0];
					newAcc.systemCode = account.CodSistema;
					newAcc.user = newUser;

					return newAcc;

				});

				Auth.getInstance().setAccountsList(this.accounts);

			}

			return this.accounts;

		}));
	}

	/**
	 * Retorna se o susuário tem senha ou não
	 *
	 * TODO: Este método é mockado, deve ser adaptado ao serviço real.
	 *
	 * @param cpf:String
	 * @param handler:Function
	 */
	getUserByCpf(cpf: string): Observable<Access> {

		// this.http.get('assets/mockup/has-pass.json').subscribe((data: any) => {
		return this.http.get(endpoints.accounts.users + cpf).pipe(map((data: any) => {

			const acc = new Access();

			if (data.Sucesso) {
				Auth.cpf = cpf;
				Auth.hasToken = data.Retorno.TokenRequerido;
				acc.exists = data.Retorno.Existente;
				acc.hasPassAccess = data.Retorno.SenhaAcessoDefinida;
				acc.passAccessBlocked = data.Retorno.SenhaAcessoBloqueada;
				acc.hasPassTransaction = data.Retorno.SenhaTransacaoDefinida;
				acc.hasSecurityQuestions = data.Retorno.PerguntaDefinida;
				acc.acceptTerms = data.Retorno.TermosUsoAppAceito;
				acc.termsText = data.Retorno.TermosUsoApp;
			}

			return acc;

		}));
	}

	createPass(pass: string, cpf: string): Observable<any> {
		const data = {
			CPF: cpf,
			Senha: pass
		};

		return this.http.post(endpoints.accounts.defineAccessPassword, data);
	}

	/**
	 * Edita a senha passando CPF, PASSWORD e uma função de retorno.
	 *
	 * TODO: Este método é mockado, deve ser adaptado ao serviço real.
	 */
	alterPass(pass: string, cpf: string): Observable<any> {
		const data = {
			CPF: cpf,
			Senha: pass
		};

		return this.http.put(endpoints.accounts.redefineAccessPassword, data);
	}

	createSubscribe(pass: string, cpf: string): Observable<any> {
		const data = {
			CPF: cpf,
			Senha: pass
		};

		return this.http.post(endpoints.accounts.defineTransactionPassword, data);
	}


	getSecurityQuestions(cpf: string): Observable<IBQuestion[]> {
		return this.http.get<IBQuestion[]>(endpoints.accounts.ibSecurityQuestions + "/" + cpf)

	}

	getPositiveId(cpf: string): Observable<IBQuestion[]> {
		return this.http.get<IBQuestion[]>(endpoints.accounts.ibPositiveId + "/" + cpf)
	}

	validateSecurityQuestions(answers, cpf) {
		return this.http.post(endpoints.accounts.ibSecurityQuestions, { answers, cpf });
	}

	validatePositiveIdentification(answers, cpf) {
		return this.http.post(endpoints.accounts.ibPositiveId, { answers, cpf });
	}

	getForRegistrationSecurityQuestions(): Observable<Question[]> {

		return this.http.get(endpoints.accounts.securityQuestions).pipe(map((data: any) => {
			return data.Retorno.map(item => {
				const question = new Question();
				question.code = item.ID;
				question.description = item.Pergunta;

				return question;
			});
		}));

	}

	saveSecurityQuestions(answers) {

		const questions = answers.map(item => {
			const question = {
				DescricaoPergunta: item.description,
				RespostaPergunta: item.answer,
				CodigoPergunta: item.code
			}

			return question;
		});


		const questionData =
		{
			Perguntas: questions
		}

		return this.http.post(endpoints.accounts.securityQuestions, questionData);


	}

	getSmsCode(cpf) {

		return this.http.get(endpoints.accounts.users + cpf + endpoints.accounts.sms).pipe(map((data: any) => {

			const sms = new Sms();
			sms.uniqueNumer = data.Retorno.NroUnicoMsg;
			sms.type = data.Retorno.TpCodValidacao;
			sms.size = data.Retorno.TamCodValidacao;
			sms.lastDigits = data.Retorno.UltimosDigitosCelular;
			sms.message = data.Mensagem;

			return sms;

		}));

	}

	sendSmsCode(cpf, code) {

		const smsData = {
			Documento: cpf,
			CodigoValidacao: code
		};

		return this.http.post(endpoints.accounts.enviarSms, smsData);

	}

	sendTokenCode(cpf, code, password) {

		const tokenData = {
			CodValidacao: code
		};

		return this.http.post(environment.apiUrl + 'contas/token/codigo/' + cpf, tokenData);

	}

	sendSummarizedEvent() {
		const params = new HttpParams();
		const tokenV2 = sessionStorage.getItem('_OmniBearerV2');

		const options = { params };
		if (tokenV2) {
			options['headers'] = new HttpHeaders({ Authorization: 'v2' });
		}

		this.http.post(endpoints.analytics.access, {
			canal: 'INTERNET',
		}, options).subscribe();
	}


	setAccount() {
		const accountData = {
			CPF: Auth.getInstance().getUser().cpf,
			Agencia: Auth.getInstance().getUser().agency,
			Conta: Auth.getInstance().getUser().accountNumber
		};

		return this.http.post(endpoints.accounts.selection, accountData);

	}

	sendDigitalSignature(dataDigitalSignature: string): Observable<any> {
		const dataValidSignature = {
			'Senha': dataDigitalSignature
		};

		return this.http.post(endpoints.accounts.validateTransactionPassword, dataValidSignature, {});
	}

	getConfig() {
		return this.http.get(endpoints.utils.config);
	}

	// logoutUser() {
	// 	return this.http.post( environment.apiUrl + 'logout', {} );
	// }

	getMyLimits() {
		return this.http.get(`${endpoints.limits.getLimits}?tipoLimite=TODOS`);
	}

	requestTokenSMS() {
		return this.http.get(endpoints.accounts.tokenSMS);
	}

	getUserAttendant(cpf: string, pass: string): Observable<Boolean> {
		return this.http.post(endpoints.attendant.login, { CPF: cpf, Senha: pass }).pipe(map((data: any) => {
			return data.Sucesso;
		}));
	}

	getTerms(): Observable<BaseResult<any>> {
		return this.http.get<BaseResult<any>>(endpoints.utils.terms);
	}

	getPixAccessAvailable(): Observable<BaseResult<boolean>> {
		return this.http.get<BaseResult<boolean>>(endpoints.pix.available);
	}

}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/autentication.service.ts